import React from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line no-restricted-imports
import UserLoginButtonContainer from 'dpl/UserAuth/containers/UserLoginButtonContainer';

export default function EmailUnavailableErrorMessage({ onLoginClick }) {
  return (
    <span>
      Looks like that email address is already associated with an
      account.&nbsp;
      <UserLoginButtonContainer className="underline fw-medium" onClick={ onLoginClick } />
    </span>
  );
}

EmailUnavailableErrorMessage.propTypes = {
  onLoginClick: PropTypes.func
};

EmailUnavailableErrorMessage.defaultProps = {
  onLoginClick: null
};
